import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './gist.scss'

// https://gist.github.com/svenadlung/eb9fead18f9f2b760cbd773ea29fb9f4
class Gist extends PureComponent {
	state = {}

	componentDidMount() {
		const { node } = this.props
		const { data } = node

		this.load(data.get('url'))
	}

	onRemove = () => {
		const { editor, node } = this.props

		editor.removeNodeByKey(node.key)
	}

	load(url) {
		if (url) {
			this.setState({ url })
		}
	}

	render() {
		const { attributes } = this.props
		const { url } = this.state

		return url ? (
			<div className={`c-gist${attributes.className}`}>
				<EmbeddedGist
					className="c-gist__embed"
					attributes={attributes}
					gist={url}
				/>
			</div>
		) : null
	}
}

/* Embed component */
class EmbeddedGist extends PureComponent {
	constructor(props) {
		super(props)
		this.gist = props.gist
		this.file = props.file
		this.stylesheetAdded = false
		this.state = {
			isLoading: true,
			src: '',
		}
	}

	// The Gist JSON data includes a stylesheet to add to the page
	// to make it look correct. `addStylesheet` ensures we only add
	// the stylesheet one time.
	addStylesheet = href => {
		if (!this.stylesheetAdded) {
			this.stylesheetAdded = true
			const link = document.createElement('link')
			link.type = 'text/css'
			link.rel = 'stylesheet'
			link.href = href

			document.head.appendChild(link)
		}
	}

	componentDidMount() {
		const { gist, file } = this.props

		// Create a JSONP callback that will set our state
		// with the data that comes back from the Gist site
		const gistCallback = EmbeddedGist.nextGistCallback()
		window[gistCallback] = function(gist) {
			this.setState({
				isLoading: false,
				src: gist.div,
			})
			this.addStylesheet(gist.stylesheet)
		}.bind(this)

		let url = `${gist}.json?callback=${gistCallback}`
		if (file) {
			url += `&file=${file}`
		}

		// Add the JSONP script tag to the document.
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.src = url
		document.head.appendChild(script)
	}

	render() {
		const { attributes, className } = this.props

		const { isLoading, src } = this.state

		return (
			<>
				<div
					{...attributes}
					className={classNames(className, isLoading && 'is-loading')}
					dangerouslySetInnerHTML={{ __html: src }}
				/>

				{isLoading && (
					<div className="c-gist__loading">
						<span>Loading...</span>
					</div>
				)}
			</>
		)
	}
}

EmbeddedGist.propTypes = {
	gist: PropTypes.string.isRequired, // e.g. "username/id"
	file: PropTypes.string, // to embed a single specific file from the gist
}

// Each time we request a Gist, we'll need to generate a new
// global function name to serve as the JSONP callback.
let gistCallbackId = 0
EmbeddedGist.nextGistCallback = () => `embed_gist_callback_${gistCallbackId++}`

export default Gist
